import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common'; // Needed for *ngIf
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';

interface User {
  uid: string;
  email: string;
  displayName?: string;
  role?: string;
  // Add any other profile fields you expect from AuthService
}

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  user: User | null = null;
  loadingProfile = true;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    // Assuming authService.currentUser directly holds the user object
    // If it's an Observable, you would subscribe to it.
    this.user = this.authService.currentUser;
    this.loadingProfile = false;

    // Example of how you might fetch more data if currentUser is not complete
    // if (this.user && !this.user.role) {
    //   // Fetch more details from a backend service using this.user.uid
    //   // For example: this.userService.getUserDetails(this.user.uid).subscribe(details => {
    //   //   this.user = { ...this.user, ...details };
    //   // });
    // }
  }
  goBack(): void {
  this.router.navigate(['/dashboard']);
}
}